import React, { FC } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { useTranslation } from '@oolio-group/localization';
import { useSession } from '../../hooks/useSession';
import Logo from '../../component/Logo/Logo';
import { SETTINGS_SECTIONS } from './sections';
import SettingsShellStyles from './SettingsScreen.styles';

interface SettingsSidebarProps {
  selectedSectionId: string;
  onSelectSection: (sectionId: string) => void;
}

const SettingsSidebar: FC<SettingsSidebarProps> = ({
  selectedSectionId,
  onSelectSection,
}) => {
  const styles = SettingsShellStyles();
  const { translate } = useTranslation();
  const { session } = useSession();

  return (
    <View style={styles.sidebar}>
      <Text style={styles.sidebarLabel}>
        {translate('kitchenDisplay.configuration')}
      </Text>
      {/* Tab semantics rather than buttons: the rows switch between mutually
          exclusive panels, and `selected` (aria-selected) is only meaningful
          on a tab, not on a button. */}
      <View accessibilityRole="tablist">
        {SETTINGS_SECTIONS.map(section => {
          const isActive = section.id === selectedSectionId;
          return (
            <TouchableOpacity
              key={section.id}
              testID={`nav-${section.id}`}
              accessibilityRole="tab"
              accessibilityState={{ selected: isActive }}
              onPress={() => onSelectSection(section.id)}
              style={[styles.navItem, isActive && styles.navItemActive]}
            >
              <Text
                style={[
                  styles.navItemText,
                  isActive && styles.navItemTextActive,
                ]}
              >
                {translate(section.labelKey)}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
      <View style={styles.sidebarFooter}>
        <View testID="station-id">
          <Text style={styles.footerText}>
            {`${translate('kitchenDisplay.stationId')} · ${
              session?.kitchenDisplay?.deviceCode || '—'
            }`}
          </Text>
        </View>
        <View testID="app-version">
          <Text style={styles.footerText}>
            {`${translate('kitchenDisplay.stationVersion')} ${
              session?.kitchenDisplay?.appVersion || '—'
            }`}
          </Text>
        </View>
        <View style={styles.footerLogo}>
          <Logo color="mono" height={18} />
        </View>
      </View>
    </View>
  );
};

export default SettingsSidebar;
